module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMSIgdmlld0JveD0iMCAwIDEyIDExIj4KICAgIDxwYXRoIGZpbGw9IiM5QkM3NUEiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTYgOS4yNGwtMy41MjcgMS42MTQuNDQ2LTMuODUzTC4yOTQgNC4xNDZsMy44MDItLjc2N0w2IDBsMS45MDQgMy4zNzkgMy44MDIuNzY3TDkuMDgxIDdsLjQ0NiAzLjg1M3oiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/activity/exp.svg
// module id = kepN
// module chunks = 1